class ReviewsSlider extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 1;
  }
  connectedCallback() {
    this.render();
    this.initSlider();
    setTimeout(() => this.updateSliderPosition(), 100);
  }
  render() {
    const slides = Array.from(this.children);
    this.innerHTML = `
      <div class="relative w-full overflow-hidden">
        <div class="slider-container w-full overflow-hidden px-4">
          <div class="slider flex transition-transform duration-500 ease-out gap-4" style="display: flex; white-space: nowrap;">
            ${slides.map((slide) => `
              <div class="slide flex-shrink-0 rounded-[24px] border border-solid border-[#2A2A2A] transform transition duration-300 ease-out backdrop-blur-[7.5px] relative overflow-hidden flex flex-col items-center justify-center text-center p-6 lg:p-8"
                   style="width: 332px; min-width: 332px; max-width: 100%;">
                
                <!-- Icon -->
                ${slide.dataset.icon ? `<div class="flex items-center justify-center w-[54px] h-[54px] border border-[#444] rounded-full mb-4">
                    <img src="${slide.dataset.icon}" alt="icon" class="w-[22px] h-[22px]">
                </div>` : ""}

                <!-- Title -->
                <h3 class="text-[28px] text-wrap font-medium leading-[135%] tracking-[-0.84px] gradient-heading bg-gradient-to-r from-white to-[#767676] bg-clip-text text-transparent">
                  ${slide.dataset.title}
                </h3>

                <!-- Description -->
                <p class="text-[16px] text-[#919191] mt-2 text-wrap break-words break-normal whitespace-normal">
                  ${slide.dataset.description}
                </p>
              </div>
            `).join("")}
          </div>
        </div>
        
        <!-- Controls -->
        <div class="flex justify-center gap-4 mt-8">
          <button class="slider-prev w-[38px] h-[38px] flex items-center justify-center border border-solid rounded-[32px] border-[#444] transition cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.91663 14.1722L3.75 10.0055L7.91667 5.83887" stroke="white" stroke-linecap="square" stroke-linejoin="round"/>
              <path d="M4.16699 10.0049L16.667 10.0049" stroke="white" stroke-linecap="square" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="slider-next w-10 h-10 flex items-center justify-center border border-solid rounded-[32px] border-[#444] transition cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12.5004 5.83851L16.667 10.0053L12.5003 14.1719" stroke="white" stroke-linecap="square" stroke-linejoin="round"/>
              <path d="M16.25 10.0049L3.75 10.0049" stroke="white" stroke-linecap="square" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    `;
  }
  initSlider() {
    this.slider = this.querySelector(".slider");
    this.slides = this.querySelectorAll(".slide");
    this.prevButton = this.querySelector(".slider-prev");
    this.nextButton = this.querySelector(".slider-next");
    this.prevButton.addEventListener("click", () => this.prevSlide());
    this.nextButton.addEventListener("click", () => this.nextSlide());
    window.addEventListener("resize", () => this.updateSliderPosition());
    this.addTouchSupport();
    this.updateSliderPosition();
  }
  updateSliderPosition(initial = false) {
    if (this.slides.length > 0) {
      const slideWidth = 332 + 16;
      const isMobile = window.innerWidth < 1024;
      const initialShift = isMobile && initial ? 60 : 0;
      const visibleArea = (this.slider.offsetWidth - slideWidth) / 2;
      let offset = this.currentIndex * slideWidth - visibleArea - initialShift;
      offset = Math.max(0, Math.min(offset, (this.slides.length - 1) * slideWidth - visibleArea));
      this.slider.style.transform = `translateX(-${offset}px)`;
    }
  }
  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateSliderPosition();
    }
  }
  nextSlide() {
    if (this.currentIndex < this.slides.length - 1) {
      this.currentIndex++;
      this.updateSliderPosition();
    }
  }
  addTouchSupport() {
    let startX = 0;
    let endX = 0;
    this.slider.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
    });
    this.slider.addEventListener("touchmove", (e) => {
      endX = e.touches[0].clientX;
    });
    this.slider.addEventListener("touchend", () => {
      if (startX - endX > 50) {
        this.nextSlide();
      } else if (endX - startX > 50) {
        this.prevSlide();
      }
    });
  }
}
if (!customElements.get("reviews-slider")) {
  customElements.define("reviews-slider", ReviewsSlider);
}
